// extracted by mini-css-extract-plugin
export var avatarContainer = "_hu-0";
export var avatarTypingWave = "_hu-i";
export var gray = "_hu-f";
export var green = "_hu-c";
export var icon = "_hu-9";
export var image = "_hu-1";
export var lg = "_hu-6";
export var md = "_hu-5";
export var presenceDot = "_hu-b";
export var red = "_hu-d";
export var sm = "_hu-4";
export var status = "_hu-a";
export var typingDot = "_hu-h";
export var typingPill = "_hu-g";
export var xl = "_hu-7";
export var xs = "_hu-3";
export var xxl = "_hu-8";
export var xxs = "_hu-2";
export var yellow = "_hu-e";